import { render, staticRenderFns } from "./SuggestedProductsModal.vue?vue&type=template&id=28d3c202&scoped=true"
import script from "./SuggestedProductsModal.vue?vue&type=script&lang=js"
export * from "./SuggestedProductsModal.vue?vue&type=script&lang=js"
import style0 from "./SuggestedProductsModal.vue?vue&type=style&index=0&id=28d3c202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3c202",
  null
  
)

export default component.exports